<div class="collection-mobile-back" (click)="mobileFilterBack()">
  <span class="filter-back">
    <i class="fa fa-angle-left" aria-hidden="true"></i> back
</span>
</div>
<div class="collection-collapse-block border-0 open">
  <h3 class="collapse-block-title">Category</h3>
  <div class="collection-collapse-block-content">
    <div class="collection-brand-filter">
      <ul class="category-list">
        <li><a [routerLink]="'/home/left-sidebar/collection/women'">Womens Fashion</a></li>
        <li><a [routerLink]="'/home/left-sidebar/collection/men'">Mens Fashion</a></li>
        <li><a [routerLink]="'/home/left-sidebar/collection/watch'">Mens Watch</a></li>
        <li><a [routerLink]="'/home/left-sidebar/collection/beauty'">Beauty Products</a></li>
        <li><a [routerLink]="'/home/left-sidebar/collection/furniture'">Furnitures</a></li>
        <li><a [routerLink]="'/home/left-sidebar/collection/flower'">Flowers Port</a></li>
      </ul>
    </div>
  </div>
</div>
